<template>
  <div v-click-outside="closeSearchBox" class="container h-100">
    <div class="row">
      <div
        v-if="hasSelectStudentPermission"
        class="d-flex justify-content-center cursor-pointer h-100 ml-3 mr-2"
      >
        <div
          class="searchbar py-2"
          :class="{
            'mobile-responsive': isMobile,
            'searchbar--compact': navCompact && !isMobile,
          }"
          @click="toggleStudentSearchBox"
        >
          <em class="far fa-search mb-5 ml-3 custom-search-icon search_icon" />
          <input
            id="btnStudentSearch"
            type="button"
            class="search_input px-5"
            readonly
            value="Búsqueda de estudiante"
          />
        </div>
      </div>

      <div
        class="search-menu col-lg-6"
        :class="{ show: showStudentSearchBox }"
        aria-labelledby="searchPrimaryInput"
      >
        <div v-if="showStudentSearchBox" class="search-navs-wrap">
          <div
            id="tbFastStudentSearch"
            class="search-nav fast-search"
            :class="{ active: showFastSearch && !showTapRequestAlert }"
            @click="goToFastSearch()"
          >
            <div class="text-highlight">
              Búsqueda rápida
            </div>
          </div>
          <div
            v-show="displayAdvancedSearch"
            id="tbAdvancedStudentSearch"
            class="search-nav advanced-search"
            :class="{ active: !showFastSearch && !showTapRequestAlert }"
            @click="goToAdvancedSearch()"
          >
            <div class="text-highlight">
              Búsqueda avanzada
            </div>
          </div>
        </div>

        <div class="search-box-content">
          <loading
            loader="bars"
            color="#41b883"
            :width="100"
            :height="100"
            :active.sync="isLoading"
            :is-full-page="false"
          />
          <div
            v-if="showFastSearch && !showTapRequestAlert"
            class="search-box-content-item search-box-content-1"
            :class="{ active: showFastSearch }"
          >
            <Fast
              v-if="!hasAlerts"
              @on-loading="handleLoading"
              @toggleStudentSearchBox="toggleStudentSearchBox"
              @showStudentInfo="showStudentInfo"
            />
          </div>
          <div
            v-if="showAdvancedSearch"
            class="search-box-content-item search-box-content-2"
            :class="{ 'advanced-size': showAdvancedSearch }"
          >
            <Advanced
              v-if="!hasAlerts"
              @on-loading="handleLoading"
              @toggleStudentSearchBox="toggleStudentSearchBox"
              @showStudentInfo="showStudentInfo"
            />
          </div>
        </div>
        <student-message
          v-if="hasAlerts"
          :show-tap-request-alert="showTapRequestAlert"
          :has-tap-request="hasTapRequest"
          :items="alerts"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '@/store/index';
import Fast from './Fast';
import Advanced from './Advanced';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import ClickOutside from 'vue-click-outside';
import StudentMessage from './StudentMessage';

export default {
  name: 'StudentSearch',
  components: {
    Fast,
    Advanced,
    Loading,
    StudentMessage,
  },
  props: {
    // Indica que el navbar está angosto (ventana pequeña, panel docked del
    // Asistente IA, o ambos) y la búsqueda debe mostrarse solo como ícono.
    // Lo calcula Navigation.vue con una medición real del ancho disponible
    // (ver observeNavWidth/navCompact) -- no reemplaza a "isMobile" (que ya
    // trae su propio tratamiento vía .mobile-responsive), solo cubre el caso
    // en que el navbar se angosta sin que la ventana sea "móvil".
    navCompact: {
      type: Boolean,
      default: false,
      meta: {
        description:
          'El navbar no tiene espacio para el texto de búsqueda -- mostrar solo el ícono.',
        example: 'false',
      },
    },
  },
  data() {
    return {
      isLoading: false,
      showAdvancedSearch: false,
      showCheckResult: false,
    };
  },
  computed: {
    ...mapGetters({
      isMobile: 'getIsMobileDensity',
      alerts: '$_student/getStudentAlerts',
      hasTapRequest: 'getHasTapRequest',
      showTapRequestAlert: 'getShowTapRequestAlert',
    }),
    showStudentSearchBox() {
      return store.state.$_student.searchOpened;
    },
    showFastSearch() {
      return store.state.$_student.showFastSearch;
    },
    displayAdvancedSearch() {
      return !store.getters.WebServiceStudentSearchEnabled;
    },
    hasAlerts() {
      return this.alerts.length > 0;
    },
    hasSelectStudentPermission() {
      return store.getters.HasPermission('student.search');
    },
  },
  directives: {
    ClickOutside,
  },
  methods: {
    showStudentInfo(student) {
      this.$emit('showStudentInfo', student);
    },
    closeSearchBox({ toElement: element }) {
      if (
        element &&
        (element.classList.contains('prevent-close-dialog') ||
          element.classList.contains('cell'))
      )
        return;

      if (this.hasAlerts) return;

      this.showAdvancedSearch = false;
      if (this.showStudentSearchBox) {
        store.commit('$_student/toggleSearchMenu', false);
      }
    },

    handleLoading(isLoading) {
      this.isLoading = isLoading;
    },
    toggleStudentSearchBox() {
      store.commit('$_student/toggleSearchMenu');
      if (store.state.isMobileDensity) {
        store.commit('setIsNavOpen', false);
      }
    },
    goToAdvancedSearch() {
      if (!this.showAdvancedSearch && !this.hasAlerts) {
        this.showAdvancedSearch = true;
        store.commit('$_student/toogleFastSearch', false);
        store.commit('$_student/setClearStudentAlerts');
        store.commit('setShowTapRequestAlert', false); //TODO: Review Logic and functionality
      }
    },
    goToFastSearch() {
      if (!store.state.$_student.showFastSearch && !this.hasAlerts) {
        store.commit('$_student/toogleFastSearch', true);
        store.commit('$_student/setClearStudentAlerts');
        this.showAdvancedSearch = false;
      }
    },
  },
};
</script>
